/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  messages: {
    options: {
      java_package: "com.appunite.chat.model.messages",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      "(elixir_module_prefix)": "KC.Proto.Chat"
    },
    nested: {
      CreateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      UpdateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      DeleteMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      CreateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      CreateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      CreateMessageNeedToBeDeletedConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      DeleteMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          retract: {
            rule: "required",
            type: "bool",
            id: 4
          }
        }
      },
      DeleteMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          developerInfoMessageDeletionWasFaked: {
            type: "bool",
            id: 3
          }
        }
      },
      UpdateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      UpdateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      BodyTypes: {
        oneofs: {
          body: {
            oneof: [
              "text",
              "blobText",
              "ping",
              "image",
              "location",
              "attachment",
              "contact",
              "timelineForward",
              "groupEvent",
              "superuserProfile",
              "superuserPost",
              "call",
              "video",
              "audio",
              "adminGroupEvent",
              "sticker",
              "storyItemReply"
            ]
          }
        },
        fields: {
          quotedMessage: {
            type: "QuotedMessage",
            id: 30
          },
          DEPRECATEDForwarededMessageOriginalAuthorId: {
            type: "string",
            id: 31
          },
          messageForwarded: {
            type: "Forward",
            id: 32
          },
          text: {
            type: "Text",
            id: 10
          },
          blobText: {
            type: "BlobText",
            id: 11
          },
          ping: {
            type: "Ping",
            id: 16
          },
          image: {
            type: "Image",
            id: 17
          },
          location: {
            type: "Location",
            id: 18
          },
          attachment: {
            type: "Attachment",
            id: 19
          },
          contact: {
            type: "Contact",
            id: 20
          },
          timelineForward: {
            type: "TimelineForward",
            id: 21
          },
          groupEvent: {
            type: "GroupEvent",
            id: 22
          },
          superuserProfile: {
            type: "UserProfile",
            id: 23
          },
          superuserPost: {
            type: "UserPost",
            id: 24
          },
          call: {
            type: "Call",
            id: 25
          },
          video: {
            type: "Video",
            id: 26
          },
          audio: {
            type: "Audio",
            id: 27
          },
          adminGroupEvent: {
            type: "AdminGroupEvent",
            id: 28
          },
          sticker: {
            type: "Sticker",
            id: 29
          },
          storyItemReply: {
            type: "StoryItemReply",
            id: 40
          }
        },
        nested: {
          Forward: {
            fields: {
              authorUserId: {
                type: "string",
                id: 1
              },
              orignalMessageCreatedAtMillis: {
                type: "uint64",
                id: 2
              }
            }
          },
          QuotedMessage: {
            fields: {
              messageId: {
                type: "bytes",
                id: 1
              },
              actorId: {
                type: "string",
                id: 2
              },
              createdAtMillis: {
                type: "uint64",
                id: 3
              },
              body: {
                type: "BodyTypes",
                id: 4
              }
            }
          },
          Text: {
            fields: {
              body: {
                rule: "required",
                type: "string",
                id: 1
              },
              linkPreview: {
                type: "LinkPreview",
                id: 2
              },
              mentions: {
                rule: "repeated",
                type: "Mention",
                id: 3
              }
            }
          },
          LinkPreview: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              websiteUrl: {
                type: "string",
                id: 3
              },
              originalUrl: {
                type: "string",
                id: 4
              },
              description: {
                type: "string",
                id: 5
              }
            }
          },
          Mention: {
            fields: {
              actorId: {
                type: "string",
                id: 1
              },
              location: {
                type: "uint32",
                id: 2
              },
              length: {
                type: "uint32",
                id: 3
              }
            }
          },
          Sticker: {
            fields: {
              stickerUrl: {
                type: "string",
                id: 1
              },
              stickerWidth: {
                type: "uint32",
                id: 2
              },
              stickerHeight: {
                type: "uint32",
                id: 3
              },
              stickerId: {
                type: "string",
                id: 4
              }
            }
          },
          BlobText: {
            fields: {
              teaser: {
                rule: "required",
                type: "string",
                id: 1
              },
              fileUrl: {
                type: "string",
                id: 2
              }
            }
          },
          StoryItemReply: {
            oneofs: {
              body: {
                oneof: [
                  "image",
                  "video"
                ]
              }
            },
            fields: {
              storyId: {
                type: "string",
                id: 1
              },
              storyItemId: {
                type: "string",
                id: 2
              },
              replyBody: {
                type: "string",
                id: 3
              },
              image: {
                type: "Image",
                id: 6
              },
              video: {
                type: "Video",
                id: 7
              }
            },
            nested: {
              Image: {
                fields: {
                  imageUrl: {
                    type: "string",
                    id: 1
                  },
                  imageWidth: {
                    type: "int32",
                    id: 2
                  },
                  imageHeight: {
                    type: "int32",
                    id: 3
                  }
                }
              },
              Video: {
                fields: {
                  videoUrl: {
                    type: "string",
                    id: 1
                  },
                  mimeType: {
                    type: "string",
                    id: 2
                  },
                  imageWidth: {
                    type: "int32",
                    id: 3
                  },
                  imageHeight: {
                    type: "int32",
                    id: 4
                  },
                  imageUrl: {
                    type: "string",
                    id: 5
                  },
                  videoDuration: {
                    type: "int32",
                    id: 6
                  }
                }
              }
            }
          },
          Ping: {
            fields: {}
          },
          Video: {
            fields: {
              videoUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 3
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 4
              },
              imageUrl: {
                type: "string",
                id: 5
              },
              progress: {
                type: "float",
                id: 6
              },
              imageColor: {
                type: "int32",
                id: 7
              },
              imageData: {
                type: "bytes",
                id: 8
              }
            }
          },
          Image: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 2
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 3
              },
              OBSOLETEThumbImageUrl: {
                type: "string",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              imageColor: {
                type: "int32",
                id: 6
              },
              imageData: {
                type: "bytes",
                id: 7
              }
            }
          },
          Location: {
            fields: {
              latitude: {
                rule: "required",
                type: "float",
                id: 1
              },
              longitude: {
                rule: "required",
                type: "float",
                id: 2
              }
            }
          },
          Attachment: {
            fields: {
              fileUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              fileSize: {
                type: "uint64",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              fileName: {
                type: "string",
                id: 6
              }
            }
          },
          Contact: {
            fields: {
              phoneNumber: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                rule: "required",
                type: "string",
                id: 3
              }
            }
          },
          TimelineForward: {
            fields: {
              timelineId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserProfile: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserPost: {
            fields: {
              postId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          GroupEvent: {
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 2
              },
              targetUserId: {
                rule: "required",
                type: "string",
                id: 3
              }
            },
            nested: {
              Type: {
                values: {
                  CHAT_CREATED_ACTION: 0,
                  USER_LEFT_ACTION: 2,
                  USER_ADDED_ACTION: 1,
                  USER_REMOVED_ACTION: 3
                }
              }
            }
          },
          AdminGroupEvent: {
            fields: {
              type: {
                type: "Type",
                id: 1
              },
              targetUserId: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Type: {
                values: {
                  ADMIN_UNKNOWN_ACTION: 0,
                  ADMIN_ADDED_ACTION: 1,
                  ADMIN_REMOVED_ACTION: 2
                }
              }
            }
          },
          Call: {
            oneofs: {
              status: {
                oneof: [
                  "success",
                  "cancelled",
                  "noAnswer",
                  "denied"
                ]
              }
            },
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 1
              },
              success: {
                type: "Success",
                id: 2
              },
              cancelled: {
                type: "Cancelled",
                id: 3
              },
              noAnswer: {
                type: "NoAnswer",
                id: 4
              },
              denied: {
                type: "Denied",
                id: 5
              },
              callId: {
                type: "string",
                id: 6
              }
            },
            nested: {
              Type: {
                values: {
                  VIDEO: 0,
                  VOICE: 1
                }
              },
              Success: {
                fields: {
                  callTimeInMillis: {
                    rule: "required",
                    type: "uint64",
                    id: 1
                  }
                }
              },
              Cancelled: {
                fields: {}
              },
              NoAnswer: {
                fields: {}
              },
              Denied: {
                fields: {}
              }
            }
          },
          Audio: {
            fields: {
              audioUrl: {
                type: "string",
                id: 1
              },
              durationInMillis: {
                rule: "required",
                type: "uint64",
                id: 2
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 3
              },
              progress: {
                type: "float",
                id: 4
              }
            }
          }
        }
      }
    }
  },
  google: {
    nested: {
      protobuf: {
        options: {
          go_package: "github.com/golang/protobuf/protoc-gen-go/descriptor;descriptor",
          java_package: "com.google.protobuf",
          java_outer_classname: "DescriptorProtos",
          csharp_namespace: "Google.Protobuf.Reflection",
          objc_class_prefix: "GPB",
          cc_enable_arenas: true,
          optimize_for: "SPEED"
        },
        nested: {
          ObjectiveCFileOptions: {
            fields: {
              "package": {
                type: "string",
                id: 1
              },
              classPrefix: {
                type: "string",
                id: 2
              },
              relaxCamelCase: {
                type: "bool",
                id: 3
              }
            }
          },
          objectivecFileOptions: {
            type: "ObjectiveCFileOptions",
            id: 1002,
            extend: "google.protobuf.FileOptions"
          },
          FileDescriptorSet: {
            fields: {
              file: {
                rule: "repeated",
                type: "FileDescriptorProto",
                id: 1
              }
            }
          },
          FileDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              "package": {
                type: "string",
                id: 2
              },
              dependency: {
                rule: "repeated",
                type: "string",
                id: 3
              },
              publicDependency: {
                rule: "repeated",
                type: "int32",
                id: 10,
                options: {
                  packed: false
                }
              },
              weakDependency: {
                rule: "repeated",
                type: "int32",
                id: 11,
                options: {
                  packed: false
                }
              },
              messageType: {
                rule: "repeated",
                type: "DescriptorProto",
                id: 4
              },
              enumType: {
                rule: "repeated",
                type: "EnumDescriptorProto",
                id: 5
              },
              service: {
                rule: "repeated",
                type: "ServiceDescriptorProto",
                id: 6
              },
              extension: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 7
              },
              options: {
                type: "FileOptions",
                id: 8
              },
              sourceCodeInfo: {
                type: "SourceCodeInfo",
                id: 9
              },
              syntax: {
                type: "string",
                id: 12
              }
            }
          },
          DescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              field: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 2
              },
              extension: {
                rule: "repeated",
                type: "FieldDescriptorProto",
                id: 6
              },
              nestedType: {
                rule: "repeated",
                type: "DescriptorProto",
                id: 3
              },
              enumType: {
                rule: "repeated",
                type: "EnumDescriptorProto",
                id: 4
              },
              extensionRange: {
                rule: "repeated",
                type: "ExtensionRange",
                id: 5
              },
              oneofDecl: {
                rule: "repeated",
                type: "OneofDescriptorProto",
                id: 8
              },
              options: {
                type: "MessageOptions",
                id: 7
              },
              reservedRange: {
                rule: "repeated",
                type: "ReservedRange",
                id: 9
              },
              reservedName: {
                rule: "repeated",
                type: "string",
                id: 10
              }
            },
            nested: {
              ExtensionRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  },
                  options: {
                    type: "ExtensionRangeOptions",
                    id: 3
                  }
                }
              },
              ReservedRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  }
                }
              }
            }
          },
          ExtensionRangeOptions: {
            fields: {
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          FieldDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              number: {
                type: "int32",
                id: 3
              },
              label: {
                type: "Label",
                id: 4
              },
              type: {
                type: "Type",
                id: 5
              },
              typeName: {
                type: "string",
                id: 6
              },
              extendee: {
                type: "string",
                id: 2
              },
              defaultValue: {
                type: "string",
                id: 7
              },
              oneofIndex: {
                type: "int32",
                id: 9
              },
              jsonName: {
                type: "string",
                id: 10
              },
              options: {
                type: "FieldOptions",
                id: 8
              }
            },
            nested: {
              Type: {
                values: {
                  TYPE_DOUBLE: 1,
                  TYPE_FLOAT: 2,
                  TYPE_INT64: 3,
                  TYPE_UINT64: 4,
                  TYPE_INT32: 5,
                  TYPE_FIXED64: 6,
                  TYPE_FIXED32: 7,
                  TYPE_BOOL: 8,
                  TYPE_STRING: 9,
                  TYPE_GROUP: 10,
                  TYPE_MESSAGE: 11,
                  TYPE_BYTES: 12,
                  TYPE_UINT32: 13,
                  TYPE_ENUM: 14,
                  TYPE_SFIXED32: 15,
                  TYPE_SFIXED64: 16,
                  TYPE_SINT32: 17,
                  TYPE_SINT64: 18
                }
              },
              Label: {
                values: {
                  LABEL_OPTIONAL: 1,
                  LABEL_REQUIRED: 2,
                  LABEL_REPEATED: 3
                }
              }
            }
          },
          OneofDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              options: {
                type: "OneofOptions",
                id: 2
              }
            }
          },
          EnumDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              value: {
                rule: "repeated",
                type: "EnumValueDescriptorProto",
                id: 2
              },
              options: {
                type: "EnumOptions",
                id: 3
              },
              reservedRange: {
                rule: "repeated",
                type: "EnumReservedRange",
                id: 4
              },
              reservedName: {
                rule: "repeated",
                type: "string",
                id: 5
              }
            },
            nested: {
              EnumReservedRange: {
                fields: {
                  start: {
                    type: "int32",
                    id: 1
                  },
                  end: {
                    type: "int32",
                    id: 2
                  }
                }
              }
            }
          },
          EnumValueDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              },
              options: {
                type: "EnumValueOptions",
                id: 3
              }
            }
          },
          ServiceDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              method: {
                rule: "repeated",
                type: "MethodDescriptorProto",
                id: 2
              },
              options: {
                type: "ServiceOptions",
                id: 3
              }
            }
          },
          MethodDescriptorProto: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              inputType: {
                type: "string",
                id: 2
              },
              outputType: {
                type: "string",
                id: 3
              },
              options: {
                type: "MethodOptions",
                id: 4
              },
              clientStreaming: {
                type: "bool",
                id: 5,
                options: {
                  "default": false
                }
              },
              serverStreaming: {
                type: "bool",
                id: 6,
                options: {
                  "default": false
                }
              }
            }
          },
          FileOptions: {
            fields: {
              javaPackage: {
                type: "string",
                id: 1
              },
              javaOuterClassname: {
                type: "string",
                id: 8
              },
              javaMultipleFiles: {
                type: "bool",
                id: 10,
                options: {
                  "default": false
                }
              },
              javaGenerateEqualsAndHash: {
                type: "bool",
                id: 20,
                options: {
                  deprecated: true
                }
              },
              javaStringCheckUtf8: {
                type: "bool",
                id: 27,
                options: {
                  "default": false
                }
              },
              optimizeFor: {
                type: "OptimizeMode",
                id: 9,
                options: {
                  "default": "SPEED"
                }
              },
              goPackage: {
                type: "string",
                id: 11
              },
              ccGenericServices: {
                type: "bool",
                id: 16,
                options: {
                  "default": false
                }
              },
              javaGenericServices: {
                type: "bool",
                id: 17,
                options: {
                  "default": false
                }
              },
              pyGenericServices: {
                type: "bool",
                id: 18,
                options: {
                  "default": false
                }
              },
              phpGenericServices: {
                type: "bool",
                id: 42,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 23,
                options: {
                  "default": false
                }
              },
              ccEnableArenas: {
                type: "bool",
                id: 31,
                options: {
                  "default": false
                }
              },
              objcClassPrefix: {
                type: "string",
                id: 36
              },
              csharpNamespace: {
                type: "string",
                id: 37
              },
              swiftPrefix: {
                type: "string",
                id: 39
              },
              phpClassPrefix: {
                type: "string",
                id: 40
              },
              phpNamespace: {
                type: "string",
                id: 41
              },
              phpMetadataNamespace: {
                type: "string",
                id: 44
              },
              rubyPackage: {
                type: "string",
                id: 45
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                38,
                38
              ]
            ],
            nested: {
              OptimizeMode: {
                values: {
                  SPEED: 1,
                  CODE_SIZE: 2,
                  LITE_RUNTIME: 3
                }
              }
            }
          },
          MessageOptions: {
            fields: {
              messageSetWireFormat: {
                type: "bool",
                id: 1,
                options: {
                  "default": false
                }
              },
              noStandardDescriptorAccessor: {
                type: "bool",
                id: 2,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              mapEntry: {
                type: "bool",
                id: 7
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                8,
                8
              ],
              [
                9,
                9
              ]
            ]
          },
          FieldOptions: {
            fields: {
              ctype: {
                type: "CType",
                id: 1,
                options: {
                  "default": "STRING"
                }
              },
              packed: {
                type: "bool",
                id: 2
              },
              jstype: {
                type: "JSType",
                id: 6,
                options: {
                  "default": "JS_NORMAL"
                }
              },
              lazy: {
                type: "bool",
                id: 5,
                options: {
                  "default": false
                }
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              weak: {
                type: "bool",
                id: 10,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                4,
                4
              ]
            ],
            nested: {
              CType: {
                values: {
                  STRING: 0,
                  CORD: 1,
                  STRING_PIECE: 2
                }
              },
              JSType: {
                values: {
                  JS_NORMAL: 0,
                  JS_STRING: 1,
                  JS_NUMBER: 2
                }
              }
            }
          },
          OneofOptions: {
            fields: {
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          EnumOptions: {
            fields: {
              allowAlias: {
                type: "bool",
                id: 2
              },
              deprecated: {
                type: "bool",
                id: 3,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            reserved: [
              [
                5,
                5
              ]
            ]
          },
          EnumValueOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 1,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          ServiceOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 33,
                options: {
                  "default": false
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ]
          },
          MethodOptions: {
            fields: {
              deprecated: {
                type: "bool",
                id: 33,
                options: {
                  "default": false
                }
              },
              idempotencyLevel: {
                type: "IdempotencyLevel",
                id: 34,
                options: {
                  "default": "IDEMPOTENCY_UNKNOWN"
                }
              },
              uninterpretedOption: {
                rule: "repeated",
                type: "UninterpretedOption",
                id: 999
              }
            },
            extensions: [
              [
                1000,
                536870911
              ]
            ],
            nested: {
              IdempotencyLevel: {
                values: {
                  IDEMPOTENCY_UNKNOWN: 0,
                  NO_SIDE_EFFECTS: 1,
                  IDEMPOTENT: 2
                }
              }
            }
          },
          UninterpretedOption: {
            fields: {
              name: {
                rule: "repeated",
                type: "NamePart",
                id: 2
              },
              identifierValue: {
                type: "string",
                id: 3
              },
              positiveIntValue: {
                type: "uint64",
                id: 4
              },
              negativeIntValue: {
                type: "int64",
                id: 5
              },
              doubleValue: {
                type: "double",
                id: 6
              },
              stringValue: {
                type: "bytes",
                id: 7
              },
              aggregateValue: {
                type: "string",
                id: 8
              }
            },
            nested: {
              NamePart: {
                fields: {
                  namePart: {
                    rule: "required",
                    type: "string",
                    id: 1
                  },
                  isExtension: {
                    rule: "required",
                    type: "bool",
                    id: 2
                  }
                }
              }
            }
          },
          SourceCodeInfo: {
            fields: {
              location: {
                rule: "repeated",
                type: "Location",
                id: 1
              }
            },
            nested: {
              Location: {
                fields: {
                  path: {
                    rule: "repeated",
                    type: "int32",
                    id: 1
                  },
                  span: {
                    rule: "repeated",
                    type: "int32",
                    id: 2
                  },
                  leadingComments: {
                    type: "string",
                    id: 3
                  },
                  trailingComments: {
                    type: "string",
                    id: 4
                  },
                  leadingDetachedComments: {
                    rule: "repeated",
                    type: "string",
                    id: 6
                  }
                }
              }
            }
          },
          GeneratedCodeInfo: {
            fields: {
              annotation: {
                rule: "repeated",
                type: "Annotation",
                id: 1
              }
            },
            nested: {
              Annotation: {
                fields: {
                  path: {
                    rule: "repeated",
                    type: "int32",
                    id: 1
                  },
                  sourceFile: {
                    type: "string",
                    id: 2
                  },
                  begin: {
                    type: "int32",
                    id: 3
                  },
                  end: {
                    type: "int32",
                    id: 4
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  elixirModulePrefix: {
    type: "string",
    id: 1047,
    extend: "google.protobuf.FileOptions"
  },
  rpc: {
    options: {
      java_package: "com.appunite.chat.model.rpc",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      "(elixir_module_prefix)": "KC.Proto.Rpc"
    },
    nested: {
      RpcGetAllConversationsServerResponse: {
        fields: {
          nextSynchronizationToken: {
            rule: "required",
            type: "string",
            id: 1
          },
          currentUserIdentifier: {
            rule: "required",
            type: "string",
            id: 2
          },
          conversations: {
            rule: "repeated",
            type: "ConversationWithLastMessage",
            id: 3
          }
        }
      },
      ConversationWithLastMessage: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          lastMessage: {
            type: "messages.CreateMessageServerMessage",
            id: 2
          },
          messagesStatuses: {
            rule: "repeated",
            type: "messages_statuses.ConversationReceiptServerMessage",
            id: 3
          },
          currentUserMessagesStatuses: {
            type: "messages_statuses.CurrentUserUnreadMessagesServerMessage",
            id: 4
          }
        }
      },
      RpcGetMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMore: {
            rule: "required",
            type: "bool",
            id: 2
          }
        }
      },
      RpcGetMessagesDeltaServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMoreOlderMessages: {
            type: "bool",
            id: 2
          },
          hasMoreNewerMessages: {
            type: "bool",
            id: 3
          }
        }
      },
      RpcGetAllBlockedUsersServerResponse: {
        fields: {
          users: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      RpcStarMessageServerResponse: {
        fields: {}
      },
      RpcUnstarMessageServerResponse: {
        fields: {}
      },
      RpcGetAllStarredConversationsServerResponse: {
        fields: {
          conversations: {
            rule: "repeated",
            type: "ConversationWithStarredMessageIds",
            id: 1
          },
          nextToken: {
            type: "string",
            id: 2
          }
        }
      },
      ConversationWithStarredMessageIds: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          messageIds: {
            rule: "repeated",
            type: "bytes",
            id: 2
          }
        }
      },
      RpcGetAllStarredMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          }
        }
      },
      RpcLikeMessageServerResponse: {
        fields: {}
      },
      RpcDislikeMessageServerResponse: {
        fields: {}
      },
      RpcSendMessageClientRequest: {
        fields: {
          body: {
            rule: "required",
            type: "messages.BodyTypes",
            id: 1
          }
        }
      },
      RpcSendMessageServerResponse: {
        fields: {}
      },
      RpcConversationJoinLinkServerResponse: {
        fields: {
          conversationId: {
            type: "bytes",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      RpcJoinConversationMetadataServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcJoinConversationClientRequest: {
        fields: {
          joinLink: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      RpcJoinConversationServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcSearchMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          conversations: {
            rule: "repeated",
            type: "conversations.CreateConversationServerMessage",
            id: 2
          },
          nextToken: {
            type: "string",
            id: 3
          }
        }
      }
    }
  },
  conversations: {
    options: {
      java_package: "com.appunite.chat.model.conversations",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      "(elixir_module_prefix)": "KC.Proto.Chat"
    },
    nested: {
      CreateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 2
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 3
          }
        }
      },
      UpdateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      DeleteConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      CreateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 2
          }
        }
      },
      CreateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      UpdateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 4
          }
        }
      },
      UpdateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      DeleteConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          isGroup: {
            rule: "required",
            type: "bool",
            id: 3
          }
        }
      },
      DeleteConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      ConversationMetadata: {
        oneofs: {
          type: {
            oneof: [
              "groupMetadata",
              "singleMetadata"
            ]
          }
        },
        fields: {
          groupMetadata: {
            type: "GroupConversationMetadata",
            id: 1
          },
          singleMetadata: {
            type: "SingleConversationMetadata",
            id: 2
          }
        }
      },
      GroupConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          avatar: {
            type: "string",
            id: 2
          },
          name: {
            rule: "required",
            type: "string",
            id: 3
          },
          creatorId: {
            rule: "required",
            type: "string",
            id: 4
          },
          adminIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          externalMetadata: {
            type: "bytes",
            id: 6
          }
        }
      },
      SingleConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  messages_statuses: {
    options: {
      java_package: "com.appunite.chat.model.statuses",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      "(elixir_module_prefix)": "KC.Proto.Chat"
    },
    nested: {
      ConversationReceiptServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 2
          },
          latestDeliveredMessageCreatedAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 4
          },
          unreadMessagesCount: {
            type: "uint64",
            id: 5,
            options: {
              "default": 0
            }
          }
        }
      },
      CurrentUserUnreadMessagesServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          unreadMessagesCount: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 5
          }
        }
      },
      UpdateConversationDeliveredClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          unreadMessagesCount: {
            type: "uint64",
            id: 3,
            options: {
              "default": 0
            }
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 5
          }
        }
      }
    }
  },
  contact: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      "(elixir_module_prefix)": "KC.Proto.Contact",
      swift_prefix: ""
    },
    nested: {
      ContactsRequest: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "DeviceContact",
            id: 1
          }
        },
        nested: {
          DeviceContact: {
            fields: {
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      ContactsResponse: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "ContactMessage",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        },
        nested: {
          ContactMessage: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              },
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      AddContactRequest: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      AddContactResponse: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  user: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      java_outer_classname: "UserModule",
      "(elixir_module_prefix)": "KC.Proto.User",
      swift_prefix: ""
    },
    nested: {
      PresenceMessage: {
        oneofs: {
          presence: {
            oneof: [
              "online",
              "offline",
              "neverSeen"
            ]
          }
        },
        fields: {
          online: {
            type: "Online",
            id: 2
          },
          offline: {
            type: "Offline",
            id: 3
          },
          neverSeen: {
            type: "NeverSeen",
            id: 4
          }
        },
        nested: {
          Online: {
            fields: {}
          },
          Offline: {
            fields: {
              lastSeenInMillis: {
                rule: "required",
                type: "int64",
                id: 1
              }
            }
          },
          NeverSeen: {
            fields: {}
          }
        }
      },
      User: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          postsCount: {
            type: "int32",
            id: 4
          },
          superuser: {
            type: "Superuser",
            id: 5
          },
          userBio: {
            type: "string",
            id: 6
          },
          avatarUrl: {
            type: "string",
            id: 7
          },
          avatarMainColor: {
            type: "int32",
            id: 8
          },
          privateAccount: {
            type: "bool",
            id: 9,
            options: {
              "default": false
            }
          },
          badgeIds: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          presence: {
            type: "PresenceMessage",
            id: 11
          }
        },
        nested: {
          Superuser: {
            fields: {
              DEPRECATEDWebsiteUrl: {
                type: "string",
                id: 1
              },
              location: {
                type: "string",
                id: 2
              },
              coverUrl: {
                type: "string",
                id: 3
              },
              accountType: {
                type: "string",
                id: 4
              },
              followersCount: {
                type: "int32",
                id: 5
              },
              contactEmail: {
                type: "string",
                id: 6
              },
              contactPhoneNumber: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      UserResponse: {
        fields: {
          user: {
            rule: "required",
            type: "user.User",
            id: 1
          }
        }
      },
      PostSuperusersSharersResponse: {
        fields: {
          userIds: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        }
      },
      GetUserByUsernameResponse: {
        fields: {
          userId: {
            type: "string",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        }
      },
      GetUserByUsernameError: {
        fields: {
          code: {
            type: "Code",
            id: 1
          },
          userMessage: {
            type: "string",
            id: 2
          }
        },
        nested: {
          Code: {
            values: {
              UNKNOWN: 0,
              USER_NOT_FOUND: 1
            }
          }
        }
      }
    }
  },
  com: {
    nested: {
      newmedia: {
        nested: {
          kingscloud: {
            options: {
              swift_prefix: ""
            },
            nested: {
              Type: {
                values: {
                  file: 0,
                  audio: 1,
                  video: 2,
                  photo: 3,
                  archive: 4,
                  folder: 5,
                  note: 6,
                  voice: 7
                }
              },
              Status: {
                values: {
                  processing: 0,
                  uploaded: 1,
                  removed: 2
                }
              },
              Item: {
                fields: {
                  id: {
                    type: "string",
                    id: 1
                  },
                  name: {
                    type: "string",
                    id: 2
                  },
                  size: {
                    type: "uint64",
                    id: 3
                  },
                  createdAtMillis: {
                    type: "uint64",
                    id: 4
                  },
                  updatedAtMillis: {
                    type: "uint64",
                    id: 5
                  },
                  parentItemId: {
                    type: "string",
                    id: 6
                  },
                  thumbnailUrl: {
                    type: "string",
                    id: 7
                  },
                  type: {
                    type: "Type",
                    id: 8
                  },
                  status: {
                    type: "Status",
                    id: 9
                  }
                }
              },
              ItemsResponse: {
                fields: {
                  items: {
                    rule: "repeated",
                    type: "Item",
                    id: 1
                  },
                  nextToken: {
                    type: "string",
                    id: 2
                  }
                }
              },
              ItemsError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              FilePresignedUrlRequest: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  parentItemId: {
                    type: "string",
                    id: 2
                  },
                  mimeType: {
                    type: "string",
                    id: 3
                  },
                  type: {
                    type: "Type",
                    id: 4
                  },
                  size: {
                    type: "uint64",
                    id: 5
                  }
                }
              },
              FilePresignedUrlResponse: {
                fields: {
                  presignedUrl: {
                    type: "string",
                    id: 1
                  },
                  item: {
                    type: "Item",
                    id: 2
                  }
                }
              },
              FilePresignedUrlError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0,
                      STORAGE_LIMIT: 1
                    }
                  }
                }
              },
              CreateFolderRequest: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  parentItemId: {
                    type: "string",
                    id: 2
                  }
                }
              },
              CreateFolderResponse: {
                fields: {
                  item: {
                    type: "Item",
                    id: 2
                  }
                }
              },
              CreateFolderError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              ShareLinkResponse: {
                fields: {
                  shortLink: {
                    type: "string",
                    id: 1
                  }
                }
              },
              ShareLinkError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              SharedFileResponse: {
                fields: {
                  presignedUrl: {
                    type: "string",
                    id: 1
                  },
                  item: {
                    type: "Item",
                    id: 2
                  }
                }
              },
              SharedFileError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              DownloadPresignedUrlResponse: {
                fields: {
                  presignedUrl: {
                    type: "string",
                    id: 1
                  }
                }
              },
              DownloadPresignedUrlError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              UpdateFileRequest: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  size: {
                    type: "uint64",
                    id: 2
                  }
                }
              },
              UpdateFileResponse: {
                fields: {
                  item: {
                    type: "Item",
                    id: 1
                  }
                }
              },
              UpdateFolderRequest: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  }
                }
              },
              UpdateFolderResponse: {
                fields: {
                  item: {
                    type: "Item",
                    id: 1
                  }
                }
              },
              StorageResponse: {
                fields: {
                  availableStorage: {
                    type: "uint64",
                    id: 1
                  },
                  usedStorage: {
                    type: "uint64",
                    id: 2
                  }
                }
              },
              StorageError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  userMessage: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0
                    }
                  }
                }
              },
              ShareItemRequest: {
                fields: {
                  recipientsIds: {
                    rule: "repeated",
                    type: "string",
                    id: 1
                  },
                  message: {
                    type: "string",
                    id: 2
                  },
                  actions: {
                    rule: "repeated",
                    type: "string",
                    id: 3
                  }
                }
              },
              ShareItemResponse: {
                fields: {}
              },
              ShareItemError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  message: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0,
                      UNAUTHORIZED: 1,
                      ALREADY_SHARED: 2,
                      SHARING_TO_SELF: 3
                    }
                  }
                }
              },
              RemoveItemsRequest: {
                fields: {
                  itemIds: {
                    rule: "repeated",
                    type: "string",
                    id: 1
                  }
                }
              },
              RemoveItemsError: {
                fields: {
                  code: {
                    type: "Code",
                    id: 1
                  },
                  message: {
                    type: "string",
                    id: 2
                  }
                },
                nested: {
                  Code: {
                    values: {
                      UNKNOWN: 0,
                      NOT_FOUND: 1
                    }
                  }
                }
              }
            }
          },
          auth: {
            nested: {
              model: {
                options: {
                  "(elixir_module_prefix)": "KC.Proto.OAuth2",
                  swift_prefix: ""
                },
                nested: {
                  ApplicationRequest: {
                    fields: {
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    }
                  },
                  ApplicationResponse: {
                    fields: {
                      applicationName: {
                        type: "string",
                        id: 1
                      },
                      applicationUrl: {
                        type: "string",
                        id: 2
                      },
                      applicationAuthenticated: {
                        type: "bool",
                        id: 3
                      }
                    }
                  },
                  ApplicationError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  AuthRequest: {
                    fields: {
                      scope: {
                        rule: "repeated",
                        type: "string",
                        id: 1
                      },
                      responseType: {
                        type: "ResponseType",
                        id: 2
                      },
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    },
                    nested: {
                      ResponseType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1
                        }
                      }
                    }
                  },
                  AuthResponse: {
                    fields: {
                      code: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  AuthError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  TokenRequest: {
                    fields: {
                      clientId: {
                        type: "string",
                        id: 1
                      },
                      grantType: {
                        type: "GrantType",
                        id: 2
                      },
                      code: {
                        type: "string",
                        id: 3
                      },
                      refreshToken: {
                        type: "string",
                        id: 4
                      }
                    },
                    nested: {
                      GrantType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1,
                          REFRESH_TOKEN: 2
                        }
                      }
                    }
                  },
                  TokenResponse: {
                    fields: {
                      accessToken: {
                        type: "string",
                        id: 1
                      },
                      expiresInMillis: {
                        type: "uint32",
                        id: 2
                      },
                      refreshToken: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  TokenError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          LOGGED_OUT: 1
                        }
                      }
                    }
                  },
                  CertsResponse: {
                    fields: {
                      certificates: {
                        rule: "repeated",
                        type: "Certificate",
                        id: 1
                      }
                    },
                    nested: {
                      Certificate: {
                        fields: {
                          kid: {
                            type: "string",
                            id: 1
                          },
                          pemCertificate: {
                            type: "string",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  ApplicationData: {
                    oneofs: {
                      applicationData: {
                        oneof: [
                          "ios",
                          "android"
                        ]
                      }
                    },
                    fields: {
                      ios: {
                        type: "Ios",
                        id: 1
                      },
                      android: {
                        type: "Android",
                        id: 2
                      }
                    },
                    nested: {
                      Ios: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          redirectUri: {
                            type: "string",
                            id: 2
                          },
                          applicationBundleId: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      Android: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          packageName: {
                            type: "string",
                            id: 2
                          },
                          applicationSignatureSha1: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          profile: {
            nested: {
              model: {
                options: {
                  optimize_for: "LITE_RUNTIME",
                  "(elixir_module_prefix)": "KC.Proto.Profile",
                  swift_prefix: ""
                },
                nested: {
                  Gender: {
                    values: {
                      UNKNOWN: 0,
                      MALE: 1,
                      FEMALE: 2
                    }
                  },
                  Profile: {
                    fields: {
                      user: {
                        type: "user.User",
                        id: 1
                      },
                      gender: {
                        type: "Gender",
                        id: 2
                      },
                      email: {
                        type: "Email",
                        id: 3
                      },
                      countryCode: {
                        type: "string",
                        id: 17
                      },
                      phoneNumber: {
                        type: "string",
                        id: 4
                      },
                      birthDateInMillis: {
                        type: "int64",
                        id: 5
                      },
                      connectedToFacebook: {
                        type: "bool",
                        id: 9
                      },
                      facebookName: {
                        type: "string",
                        id: 19
                      },
                      hasPassword: {
                        type: "bool",
                        id: 10
                      },
                      blockedUserIds: {
                        rule: "repeated",
                        type: "string",
                        id: 11
                      },
                      hiddenUserIds: {
                        rule: "repeated",
                        type: "string",
                        id: 12
                      },
                      followedSuperuserIds: {
                        rule: "repeated",
                        type: "string",
                        id: 13
                      },
                      subscribedSuperuserIds: {
                        rule: "repeated",
                        type: "string",
                        id: 14
                      },
                      barcodeId: {
                        type: "string",
                        id: 18
                      },
                      barcodeColor: {
                        type: "string",
                        id: 7
                      },
                      church: {
                        type: "string",
                        id: 8
                      },
                      cloudSpace: {
                        type: "uint32",
                        id: 15
                      },
                      usedSpace: {
                        type: "uint32",
                        id: 16
                      }
                    },
                    nested: {
                      Email: {
                        fields: {
                          address: {
                            type: "string",
                            id: 1
                          },
                          verified: {
                            type: "bool",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  ProfileResponse: {
                    fields: {
                      profile: {
                        type: "Profile",
                        id: 1
                      }
                    }
                  },
                  ProfileUpdateRequest: {
                    fields: {
                      name: {
                        type: "string",
                        id: 1
                      },
                      username: {
                        type: "string",
                        id: 2
                      },
                      email: {
                        type: "string",
                        id: 3
                      },
                      avatarUrl: {
                        type: "string",
                        id: 4
                      },
                      password: {
                        type: "string",
                        id: 5
                      },
                      gender: {
                        type: "Gender",
                        id: 6
                      },
                      bio: {
                        type: "BioChange",
                        id: 7
                      },
                      privateAccount: {
                        type: "PrivacyChange",
                        id: 8
                      },
                      birthDate: {
                        type: "BirthDateChange",
                        id: 9
                      },
                      phoneNumber: {
                        type: "PhoneNumberChange",
                        id: 10
                      },
                      facebook: {
                        type: "FacebookChange",
                        id: 11
                      }
                    },
                    nested: {
                      PrivacyChange: {
                        fields: {
                          privateAccount: {
                            type: "bool",
                            id: 1
                          }
                        }
                      },
                      BirthDateChange: {
                        fields: {
                          birthDate: {
                            type: "int64",
                            id: 1
                          }
                        }
                      },
                      BioChange: {
                        fields: {
                          bio: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      PhoneNumberChange: {
                        fields: {
                          OBSOLETECountryCode: {
                            type: "string",
                            id: 1,
                            options: {
                              deprecated: true
                            }
                          },
                          OBSOLETEPhone: {
                            type: "string",
                            id: 2,
                            options: {
                              deprecated: true
                            }
                          },
                          firebaseToken: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      FacebookChange: {
                        fields: {
                          facebookToken: {
                            type: "string",
                            id: 1
                          }
                        }
                      }
                    }
                  },
                  ProfileUpdateResponse: {
                    fields: {
                      profile: {
                        type: "Profile",
                        id: 1
                      }
                    }
                  },
                  ProfileUpdateError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      message: {
                        type: "string",
                        id: 2
                      },
                      formErrors: {
                        rule: "repeated",
                        type: "FormValidationError",
                        id: 3
                      }
                    },
                    nested: {
                      FormValidationError: {
                        fields: {
                          code: {
                            type: "ErrorCode",
                            id: 1
                          },
                          message: {
                            type: "string",
                            id: 2
                          }
                        },
                        nested: {
                          ErrorCode: {
                            values: {
                              UNKNOWN: 0,
                              NAME: 1,
                              USERNAME: 2,
                              PHONE_NUMBER: 3,
                              PHONE_HASH: 4,
                              FACEBOOK_ID: 5,
                              PASSWORD: 6
                            }
                          }
                        }
                      },
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          VALIDATION_FAILED: 1,
                          FB_CONNECTION_FAILURE: 2,
                          FIREBASE_AUTH_ERROR: 3,
                          EMAIL_ALREADY_CONFIRMED: 4
                        }
                      }
                    }
                  },
                  VerifyEmailRequest: {
                    fields: {}
                  },
                  VerifyEmailResponse: {
                    fields: {}
                  },
                  VerifyEmailError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      message: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          EMAIL_TAKEN: 1,
                          NO_PENDING_VERIFICATION: 2
                        }
                      }
                    }
                  },
                  VerifyPhoneRequest: {
                    fields: {
                      countryCode: {
                        type: "string",
                        id: 1
                      },
                      phone: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  VerifyPhoneResponse: {
                    fields: {}
                  },
                  VerifyPhoneError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      message: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          INVALID_FORMAT: 1,
                          NUMBER_TAKEN: 2
                        }
                      }
                    }
                  },
                  ProfileBadgeResponse: {
                    fields: {
                      id: {
                        type: "string",
                        id: 1
                      },
                      title: {
                        type: "string",
                        id: 2
                      },
                      description: {
                        type: "string",
                        id: 3
                      },
                      imageUrl: {
                        type: "string",
                        id: 4
                      },
                      signature: {
                        type: "bool",
                        id: 5
                      }
                    }
                  },
                  ProfileBadgeError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          NOT_FOUND: 1
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;
